import { shopId } from "../config/const";
import { callFetch, header } from "./utils";

const EndPoint = {
  GetShop: (lineId) =>
    `/linewebhook/shops/shop/${shopId}/oauth/${lineId}/info?options=id,contact_name,contact_href,liff_id,settings.bvlgari`,
};

// Shop
export function getShop(liffToken, lineId) {
  const uri = EndPoint.GetShop(lineId);
  let settings = {
    method: "POST",
    headers: header,
    body: JSON.stringify({
      accessToken: liffToken,
    }),
  };

  return callFetch(uri, settings, "tp");
}
